import { apiProxyRequest as request } from "Api/apiProxyRequest";

import { Team } from "./teams.types";

export const getTeam = (teamId: string) => request<Team>(`/teams/${teamId}`);
